<h2 mat-dialog-title>Preview Send — PO {{ data.orderNo }}</h2>

<mat-dialog-content style="min-width:480px;max-width:680px">

	<div *ngIf="loading" class="text-muted small py-3">
		<mat-spinner diameter="20" class="d-inline-block mr-2" style="vertical-align:middle"></mat-spinner>
		Building preview…
	</div>

	<div *ngIf="error" class="alert alert-danger py-2 small">{{ error }}</div>

	<ng-container *ngIf="preview && !loading">

		<div *ngIf="preview.skipped" class="alert alert-info py-2 small">
			No 3PL in-scope lines on this PO — send will be skipped automatically.
		</div>

		<ng-container *ngIf="!preview.skipped && preview.payload">

			<!-- PO / vendor / SKU count summary -->
			<table class="table table-sm table-bordered mb-2" style="font-size:0.82rem">
				<tbody>
					<tr>
						<th class="text-nowrap" style="width:130px">Supplier ID</th>
						<td><strong>{{ preview.supplier_id || '—' }}</strong></td>
						<th class="text-nowrap" style="width:130px">Supplier Name</th>
						<td>{{ preview.supplier_name || '—' }}</td>
					</tr>
					<tr>
						<th class="text-nowrap">Vendor (PGS)</th>
						<td>{{ preview.payload.vendorName }}</td>
						<th class="text-nowrap">Warehouse</th>
						<td>{{ preview.payload.warehouse }}</td>
					</tr>
					<tr>
						<th class="text-nowrap">Order Date</th>
						<td>{{ preview.payload.orderDate }}</td>
						<th class="text-nowrap">SKUs on PO</th>
						<td>
							<strong>{{ preview.total_skus }}</strong>
							<span class="text-muted ml-1">
								(<span [ngClass]="allReady ? 'text-success' : 'text-danger'">{{ (preview.total_skus ?? 0) - missingCount }} ready</span>
								<span *ngIf="missingCount > 0">, <span class="text-danger">{{ missingCount }} missing from 3PL</span></span>)
							</span>
						</td>
					</tr>
				</tbody>
			</table>

			<!-- SKU readiness banner -->
			<div class="alert py-2 mb-2 d-flex align-items-center" style="gap:6px"
				[ngClass]="allReady ? 'alert-success' : 'alert-warning'">
				<mat-icon style="font-size:18px;line-height:18px">
					{{ allReady ? 'check_circle' : 'warning' }}
				</mat-icon>
				<span class="small" *ngIf="allReady">
					All {{ preview.total_skus }} SKUs are pushed to 3PL — ready to send.
				</span>
				<span class="small" *ngIf="!allReady">
					<strong>{{ missingCount }} of {{ preview.total_skus }} SKUs not yet pushed to 3PL.</strong>
					The send may fail again until missing SKUs are pushed.
				</span>
			</div>

			<!-- Line items with SKU readiness -->
			<table class="table table-sm table-bordered mb-0" style="font-size:0.8rem">
				<thead>
					<tr>
						<th>SKU</th>
						<th>Description</th>
						<th class="text-end">Qty</th>
						<th class="text-center">In 3PL</th>
					</tr>
				</thead>
				<tbody>
					<tr *ngFor="let s of preview.sku_check"
						[ngClass]="s.in_3pl ? '' : 'table-warning'">
						<td class="font-monospace font-weight-bold">{{ s.sku }}</td>
						<td class="small">{{ s.description || '—' }}</td>
						<td class="text-end">{{ s.qty }}</td>
						<td class="text-center">
							<mat-icon style="font-size:16px;line-height:16px"
								[ngClass]="s.in_3pl ? 'text-success' : 'text-danger'">
								{{ s.in_3pl ? 'check_circle' : 'cancel' }}
							</mat-icon>
						</td>
					</tr>
				</tbody>
			</table>

		</ng-container>
	</ng-container>

</mat-dialog-content>

<mat-dialog-actions align="end">
	<button mat-button (click)="close()" [disabled]="sending">Cancel</button>
	<button mat-raised-button
		[color]="allReady ? 'primary' : 'accent'"
		(click)="send()"
		[disabled]="sending || loading || !!error || preview?.skipped"
		[matTooltip]="!allReady ? 'Some SKUs are not yet in 3PL — send may fail again' : ''">
		<mat-spinner *ngIf="sending" diameter="18" style="display:inline-block;vertical-align:middle;margin-right:4px"></mat-spinner>
		<mat-icon *ngIf="!sending">send</mat-icon>
		{{ sending ? 'Sending…' : (allReady ? 'Send Now' : 'Send Anyway') }}
	</button>
</mat-dialog-actions>
